import { gql, useMutation } from '@apollo/client';
import { REFETCH_USER_VIEWS } from './useUserViews';

export const ADD_USER_VIEW_MUTATION = gql`
  mutation AddUserView($viewInput: CreateViewInput!) {
    addUserView(viewInput: $viewInput) {
      base64Embedding
      createdAt
      lastModified
      userEmail
      viewId
      viewName
      appName
    }
  }
`;

export const useAddUserView = () => {
  const [addUserView, state] = useMutation(ADD_USER_VIEW_MUTATION, {
    refetchQueries: [REFETCH_USER_VIEWS],
  });

  return { addUserView, ...state };
};
